import http from '@/assets/js/http'
function Api() { }
Api.listCategory = async function () {
  let res = await http.post('/do/6126.20')
  return res.data
}
Api.listCommodity = async function (plate_name) {
  let res = await http.post('/do/6126.21', {
    plate_name
  })
  return res.data
}
Api.listPeriodBasis = async function (future_code) {
  let res = await http.post('/do/6126.22', {
    future_code
  })
  return res.data
}
Api.getMainBasis = async function (future_code) {
  let res = await http.post('/do/6126.23', {
    future_code
  })
  return res.data
}
Api.listHistoryBasis = async function (future_code) {
  let res = await http.post('/do/6126.24', {
    future_code
  })
  return res.data
}
Api.listMoreHistoryBasis = async function (future_code) {
  let res = await http.post('/do/6126.25', {
    future_code
  })
  return res.data
}
Api.listBasisSummary = async function (date) {
  let res = await http.post('/do/6126.26', {
    date
  })
  return res.data
}
Api.listSeasonBasis = async function (future_code) {
  let res = await http.post('/do/6126.27', {
    future_code
  })
  return res.data
}
Api.fuzzyCommodity = async function (fuzzy) {
  let res = await http.post('/do/6126.28', {
    fuzzy
  })
  return res.data
}
Api.getNearDaySeasonBasisData = async function (future_code) {
  let res = await http.post('/do/6126.29', {
    future_code
  })
  return res.data
}
Api.listSpreadCommodity = async function () {
  let res = await http.post('/do/6126.30')
  return res.data
}
Api.listPeriodSpread = async function (spread_config_id) {
  let res = await http.post('/do/6126.31', {
    spread_config_id
  })
  return res.data
}
Api.listHistorySpread = async function (spread_config_id) {
  let res = await http.post('/do/6126.32', {
    spread_config_id
  })
  return res.data
}
Api.listMoreHistorySpread = async function (spread_config_id) {
  let res = await http.post('/do/6126.33', {
    spread_config_id
  })
  return res.data
}
Api.listSeasonSpread = async function (spread_config_id) {
  let res = await http.post('/do/6126.34', {
    spread_config_id
  })
  return res.data
}
Api.getNearDaySeasonSpreadData = async function (spread_config_id) {
  let res = await http.post('/do/6126.35', {
    spread_config_id
  })
  return res.data
}

export function GetCode(params) {
  return http.post('/do/6126.37', params)
}
export default Api;